const CUSTOM_PREFIX = 'ntm_'
const UTM_PREFIX = 'utm_'

const PREFIXES = [CUSTOM_PREFIX, UTM_PREFIX]

function recognisedPrefix(input: string): string | null {
  const lower = input.toLowerCase()

  return PREFIXES.find((prefix) => lower.startsWith(prefix)) ?? null
}

function normaliseBody(body: string): string {
  return (
    body
      .trim()
      .toLowerCase()
      // Decompose, then drop the combining marks, so an accented letter keeps its
      // base form rather than being dropped with the accent.
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      // Letters and digits of any script: a key may be written in any language,
      // and only its length is constrained.
      .replace(/[^\p{L}\p{N}]+/gu, '_')
      .replace(/^_+|_+$/g, '')
  )
}

/**
 * Normalises a key typed into the custom-key row, prefixing an unprefixed one as
 * customer-defined.
 *
 * The prefix is handled separately from the body so a prefixed key is neither
 * prefixed twice nor mangled — `utm_` included, since re-prefixing it yields a
 * key that validates and means nothing. Returns empty for a bare prefix or a key
 * with nothing left to normalise.
 */
export function normaliseCustomKey(input: string): string {
  const trimmed = input.trim()
  const prefix = recognisedPrefix(trimmed)
  const body = normaliseBody(prefix ? trimmed.slice(prefix.length) : trimmed)

  if (body === '') return ''

  return (prefix ?? CUSTOM_PREFIX) + body
}
